import React, { ReactNode} from "react";

import { CommonContainer } from "../../../components/commonContainer/commonContainer";
import MenuBar from "../../../components/menuBar/Menubar";
import useWindowDimensions from "../../../hooks/windowsSize";
import { Header } from "../../../components/index";

import "../../mainContanier.scss";

interface MainContentViewLayoutProps {
  children: ReactNode ;
  currentPath: string;
}

// Pre-redesign layout: fixed-width left MenuBar + header stacked above the
// content column. Kept so ENABLE_APP_SIDEBAR_REDESIGN=false still renders
// exactly as it did before the AppSidebar redesign.
export const MainContentViewLayoutLegacy = ({
  children,
  currentPath,
}: MainContentViewLayoutProps) => {
  const { width } = useWindowDimensions();

  return (
    <div style={{ width: width }}>
      <Header />
      <div className="viewMain contentHide">
        <div className="leftLayoutContent contentHide">
          <MenuBar />
        </div>
        <div className="rightContentMain">
          <CommonContainer
            currentPath={currentPath}
            styles={`customMainBottomContainer`}
          >
            {children}
          </CommonContainer>
        </div>
      </div>
    </div>
  );
};
